import { ApiClient } from "lib/utils/client/apiClient";

export interface LoginDto {
  email: string;
  password: string;
}

export interface LoginResponse {
  status: string;
  message: string;
  data: {
    accessToken: string;
    user: {
      id: string;
      email: string;
      firstName?: string;
      lastName?: string;
      role: string;
      profileImage?: string;
    };
  };
}

/**
 * Login user
 * POST /auth/login
 */
export const login = async (data: LoginDto): Promise<LoginResponse> => {
  return ApiClient('/auth/login', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * Register new user
 * POST /auth/register
 */
export const register = async (data: {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
  department?: string;
}) => {
  return ApiClient('/auth/register', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * Get current user profile
 * GET /auth/me
 */
export const getMe = async () => {
  return ApiClient('/auth/me', {
    method: 'GET',
  });
};